import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 5px;

  .btnControls {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 5px;
    min-width: 50px;
    margin-left: 10px;
    margin-top: 3px;
    background-color: transparent;
    box-shadow: 0px;;
    cursor: pointer;
    padding: 2px;
    padding-right: 10px;

    .icon-play {
      color: ${colors.lightBlue};
      background-color: ${colors.white02};
      margin-left: 3px;
      border-radius: 50%;
    }
    .icon-stop {
      color: ${colors.lightBlue};
      background-color: ${colors.white02};
      margin-left: 3px;
      border-radius: 50%;
    }
    .count { font-size: 13px; color: ${colors.black}; }
  }

`;
